module.exports = __webpack_public_path__ + "img/4.dca1c902.png";